export default __webpack_public_path__ + "static/media/2.081afec9.PNG";